import {Component, Input} from '@angular/core';
import {Artist} from "../../model/artist";

@Component({
  selector: '[app-header-artist-item]',
  templateUrl: './header-artist-item.component.html',
  styleUrls: ['./header-artist-item.component.css']
})
export class HeaderArtistItemComponent {
  @Input() artist: Artist;
}
